module.exports = __webpack_public_path__ + "static/logos/logo-intersport--color-b90dbe262988e9fa6eed4d1e798f8a7d.svg";